




























import { IConfiguration } from "../domain/configuration";
import { Component, Mixins } from "vue-property-decorator";
import { DeveloperIndicator } from "./developer";
import { default as SuspendedPresentableMixin } from "./SuspendedPresentableMixin.vue";

@Component({
  components: {
    DeveloperIndicator,
  }
})
export default class ErrorView extends Mixins(SuspendedPresentableMixin) {
  get shouldShowDetail(): boolean {
    return true;
  }

  created(): void {
    console.error("エラーによって処理を中断しました。");
    console.error(this.url);
    console.error(this.message);
  }

  get errorTitle(): string {
    const titleTexts: string[] = [];
    // 設定読み込み失敗してエラー画面に遷移した場合は設定が格納されていない
    const config = this.$store.getters.configuration as IConfiguration;
    titleTexts.push(config ? config.wording.common.errorViewTitle : "システムエラー");
    if (this.title) {
      titleTexts.push(this.title);
    }
    return titleTexts.join(" ");
  }

  get errorDescriptions(): string[] {
    // 設定読み込み失敗してエラー画面に遷移した場合は設定が格納されていない
    const config = this.$store.getters.configuration as IConfiguration;
    const desctiption = config
      ? config.wording.common.errorViewDescription
      : "予期せぬエラーによって処理を中断しました。\r\n運用中に本画面が表示される場合は、システムの管理者に連絡してください。";
    return this.splitByReturnCode(desctiption);
  }

  private splitByReturnCode(text: string): string[] {
    if (!text) { return [""]; }
    return text.split(/\r\n|\n/);
  }
}
